/**
 * Directive Metro Search
 * @module Search Component
 */
define(function (require, exports) {
    'use strict';

    exports.metListLoader = function () {
        return {
            restrict: 'E',
            replace: true,
            scope: {
                loading: '='
            },
            template: '<div class="text-center" ng-show="loading"><i class="fa fa-2x fa-spinner fa-spin"></i></div>'
        };
    };
});



// WEBPACK FOOTER //
// ./scripts/directives/metListLoader/metListLoader.js